import React, { FC } from 'react'

const GA4_ID = 'G-YCJ3B11M83'

interface GTagScriptProps {
  measurementID: string
}

const gtagSetup = (measurementID: string, ga4ID: string) => `
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 2000
});
gtag('js', new Date());
gtag('config', '${measurementID}', { server_container_url: window.location.origin + '/sth' });
window.thGA4ID = '${ga4ID}';
if (window.thGA4ID) {
  gtag('config', '${ga4ID}', { server_container_url: window.location.origin + '/sth' });
}
`

// Used to load and setup gtag.js
export const GTagScript: FC<GTagScriptProps> = (
  {
    measurementID,
  }: GTagScriptProps,
) => (
  <>
    <script
      key="gtag-load"
      async
      src={`/sth/gtag/js?id=${measurementID}`}
      type="text/javascript"
    />
    <script
      key="gtag-setup"
      dangerouslySetInnerHTML={{ __html: gtagSetup(measurementID, GA4_ID) }}
      type="text/javascript"
    />
  </>
)

export const gtagEvent = (eventType: string, data: Record<string, any>) => {
  if (typeof window === 'undefined') {
    return
  }

  const { gtag, thGA4ID } = (window as any)

  if (!gtag || !thGA4ID) {
    return
  }

  gtag('event', eventType, { ...data, send_to: thGA4ID })
}
